/**
 * REVEAL-ON-VIEW
 * Fait apparaître son contenu (fondu + léger glissement) quand il entre dans l'écran.
 * Pendant un export ou avec « réduire les animations », le contenu est affiché tout de suite : sinon une carte
 * jamais défilée à l'écran serait photographiée invisible.
 */
import { useRef } from "react"
import { motion, useInView } from "framer-motion"
import { useAnimationsDisabled } from "@/utils/animation-mode.utils"

interface OwnProps {
  children?: React.ReactNode
}

const HIDDEN = { opacity: 0, y: 24 }
const VISIBLE = { opacity: 1, y: 0 }

function RevealOnView(props: OwnProps) {
  const ref = useRef<HTMLDivElement>(null)
  const isInView = useInView(ref, { once: true, amount: 0.3 })
  const isDisabled = useAnimationsDisabled()

  return (
    <motion.div
      ref={ref}
      initial={HIDDEN}
      animate={isInView || isDisabled ? VISIBLE : HIDDEN}
      transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}>
      {props.children}
    </motion.div>
  )
}

export default RevealOnView
